const Occupation = {
    DENTIST: 'Dentist',
    DISTRIBUTOR: 'Distributor',
    DENTAL_LAB: 'Dental Lab',
    KOL: 'KOL',
    OTHER: 'Other',
    UNKNOWN: 'unknown'
}

export default Occupation